import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@fortawesome/fontawesome-free/css/all.css";
import en from "vuetify/lib/locale/en";
import es from "vuetify/lib/locale/es";
import pt from "vuetify/lib/locale/pt";
import { resolveInitialLocale } from "@/utils/locale";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: false,
  theme: { disable: true },
  icons: {
    iconfont: "fa",
  },
  lang: {
    locales: {
      "en-US": en,
      "es-MX": es,
      "pt-BR": pt,
    },
    current: resolveInitialLocale(),
  },
});
